import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterFieldService {
  sharedValue$ = new BehaviorSubject({ filter: '' });
}
